import React, { useEffect } from "react";
import UI from "@mile-meeting/mile-ui";
import { BottomSection, Container, DashboardChartContainer, TopSection } from "./MeetingRoomStatusDashboard.styles";
import MeetingRoomStatusDashboardFilter from "./MeetingRoomStatusDashboardFilter/MeetingRoomStatusDashboardFilter";
import DashboardDataTileList from "./DashboardDataTileList/DashboardDataTileList";
import * as Charts from "./Charts/Charts";
import { getMeetingMonthlyOverviewData } from "apis/analytics/meeting/dashboard";
import { TMeetingOverviewDashBoard } from "types/analytics.types";
import { LoadingModal } from "uis/modal";

const MeetingRoomStatusDashboard: React.FC = () => {
  const [filteredData, setFilteredData] = React.useState<TMeetingOverviewDashBoard>();
  const [selectedRoom, setSelectedRoom] = React.useState<string | undefined>(undefined);
  const [viewStartDate, setViewStartDate] = React.useState<Date>(new Date());
  const [viewEndDate, setViewEndDate] = React.useState<Date>(
    new Date(viewStartDate.getFullYear(), viewStartDate.getMonth() + 1, 0)
  );
  const [loading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    getFilteredData({
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      endDate: new Date(new Date().setDate(new Date().getDate())),
      selectedRoom: undefined,
    });
  }, []);

  const getFilteredData = async (data: { startDate: Date; endDate: Date; selectedRoom?: string }) => {
    setLoading(true);
    const res = await getMeetingMonthlyOverviewData({
      viewStartDate: data.startDate.toISOString(),
      viewEndDate: data.endDate.toISOString(),
      meetingRoomName: data.selectedRoom ?? undefined,
    });
    if (res.success) {
      setFilteredData(res.data);
    }
    setLoading(false);
  };

  return (
    <Container>
      <TopSection className="top-section">
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{
            padding: "24px 20px",
          }}
        >
          회의실 현황 대시보드
        </UI.Typography>
        <MeetingRoomStatusDashboardFilter
          onFilterChange={(data) => {
            setSelectedRoom(data.selectedRoom);
            getFilteredData(data);
            setViewStartDate(data.startDate);
            setViewEndDate(data.endDate);
          }}
        />
      </TopSection>
      <BottomSection className="bottom-section">
        <DashboardDataTileList data={filteredData} disabled={selectedRoom !== undefined} />
        <DashboardChartContainer>
          <Charts.RoomUsageHeatmap
            filterStartDate={viewStartDate}
            filterEndDate={viewEndDate}
            data={filteredData?.monthlyDailyMeetingTimes ?? []}
            maxMeetingTime={Math.max(
              ...(filteredData?.monthlyDailyMeetingTimes?.map((item) => item.meetingTime) ?? [0])
            )}
          />
          <Charts.DailyReservationSourceChart data={filteredData?.monthlyDailyMeetingCounts ?? []} />
          <Charts.AttendeeCountRatioChart data={filteredData?.monthlyMeetingCountByParticipants ?? []} />
        </DashboardChartContainer>
      </BottomSection>
      <LoadingModal title={"회의실 현황 데이터를 조회 중입니다."} modalIsOpen={loading} />
    </Container>
  );
};

export default React.memo(MeetingRoomStatusDashboard);
